import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducer from '../reducers'

//Prod Version
const configureStore = () => createStore(
  reducer,
  applyMiddleware(thunk)
)

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js